import { MitsIconModule } from 'src/packages/shared-ui';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { AppLogoComponent } from './app-logo.component';

@NgModule({
  imports: [CommonModule, IonicModule, FormsModule, MitsIconModule],
  declarations: [AppLogoComponent],
  entryComponents: [AppLogoComponent],
  exports: [AppLogoComponent],
  providers: [],
})
export class AppLogoModule {}
